export async function downloadDriveFile(
  fileId: string,
  fileName: string,
  accessToken: string,
  isSecondAccount: boolean,
  exportFormat?: string
): Promise<void> {
  const params = new URLSearchParams({
    fileId,
    isSecondAccount: isSecondAccount.toString(),
  });

  if (exportFormat) {
    params.set("exportFormat", exportFormat);
  }

  const response = await fetch(`/api/unifiedtime/getDrive/download?${params.toString()}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || `Download failed: ${response.statusText}`);
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
